import _ from 'lodash';

import { GATE_PASSAGES_FUTRAL_STATUS, SPOT_STATUS, STATUS_CODE } from './constants';
import regex from './validateRegex';
import Joi from 'joi-browser';

export const getGateFleetStatusName = gateFleetStatus => {
  const status = _.find(GATE_PASSAGES_FUTRAL_STATUS, ['id', gateFleetStatus]);
  return _.get(status, 'name');
};

export const getMessageGateForTooltip = gateData => {
  let status = getGateFleetStatusName(gateData.gate_fleet_status);
  if (
    _.isEqual(gateData.gate_fleet_status, GATE_PASSAGES_FUTRAL_STATUS.reject.id)
  ) {
    status = gateData.gate_fleet_message;
  }
  return status;
};

export const isStatusRejectGateFutral = gateFleetStatus =>
  gateFleetStatus === GATE_PASSAGES_FUTRAL_STATUS.reject.id;

export const isStatusAcceptGateFutral = gateFleetStatus => {
  return _.isEqual(gateFleetStatus, GATE_PASSAGES_FUTRAL_STATUS.accept.id);
};

export const schema = {
  area: Joi.string()
    .required()
    .label('area')
    .regex(regex.pattern.area),
  class_number: Joi.string()
    .required()
    .max(3)
    .label('class_number')
    .regex(regex.pattern.class_number),
  hiragana: Joi.string()
    .required()
    .max(1)
    .label('hiraganaColumn')
    .regex(regex.pattern.hiraganaColumn),
  designated_number: Joi.string()
    .required()
    .max(4)
    .regex(regex.pattern.integerNoSignHalfWidth)
    .regex(regex.pattern.designated_number),
};

export const trackCountOptions = sizeTruckCount => {
  const trackCountOptions = [];
  for (let i = 1; i <= sizeTruckCount; i++) {
    trackCountOptions.push({
      id: i,
      name: i,
    });
  }
  return trackCountOptions;
};

export const isSpotFlag = statusFlag =>
  _.isEqual(statusFlag, SPOT_STATUS.spot.id);

export const isEditConcurrentErrorGate = response => {
  return (
    response.status === STATUS_CODE.badRequest &&
    response.message ===
      '他のユーザーによって編集が行われたため、処理に失敗しました。\n閉じるボタンを押下すると画面が更新されます。ご確認のうえ改めて操作を行ってください。\n'
  );
};



// WEBPACK FOOTER //
// ./src/utilities/gatePassageUtil.js